import { Injectable, OnInit } from "@angular/core";
import { Headers, Http } from "@angular/http";
import { Observable } from "rxjs";
// import { dns } from "../global.config";
import { TypeTiers } from '../models';
import { EventForm } from "../models/events.model";
import { environment } from "../../../environments/environment";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { catchError } from "rxjs/operators";
// import { EventForm } from "../models/evenement.model";

@Injectable()
export class EvenementService implements OnInit {
    eventsUrl = environment.dns + 'api/events/';
  typeTiersUrl = environment.dns + 'api/type/tiers/';
  
  constructor(private http: HttpClient) {}

  ngOnInit(): void {
    console.log(environment);
  }

  // Update event
  update(eventform: EventForm): Observable<Event> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': localStorage.getItem('token') || '', // Get token from localStorage
    });

    return this.http
      .put<Event>(this.eventsUrl, eventform, { headers })
      .pipe(
        catchError(this.handleError) // Optional: Add error handling
      );
  }

  // Get the list of events
  getListEvent(): Observable<Event[]> {
    const headers = new HttpHeaders({
      'Authorization': localStorage.getItem('token') || '', // Get token from localStorage
    });

    return this.http
      .get<Event[]>(`${this.eventsUrl}list`, { headers })
      .pipe(
        catchError(this.handleError) // Optional: Add error handling
      );
  }

  // Optional: Handle errors
  private handleError(error: any): Observable<never> {
    console.error('An error occurred:', error);
    throw error; // Rethrow the error (or return an empty observable)
  }
}



